import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import uuidv4 from '../../utils/uuidv4';
/**
 * Bronson Checkbox component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-checkbox.html
 *
 * @constructor
 */
export function Checkbox({ children, className, errorMessage, id, required, requiredText, testId, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const checkboxId = useMemo(() => id ?? uuidv4('checkbox-'), [id]);
    const labelClassNameList = classNames('c-checkbox', className).trim();
    const inputClassNameList = classNames('c-checkbox__input').trim();
    /**
     * If {@link required} is set, render a `required` flag according {@link requiredText}.
     */
    const renderIfRequired = (required, requiredText) => {
        return required ? React.createElement("span", { "aria-hidden": "true" }, requiredText) : null;
    };
    const renderIfError = () => {
        if (!errorMessage)
            return null;
        return typeof errorMessage === 'string' ? React.createElement(ErrorMessage, { id: checkboxId }, errorMessage) : errorMessage;
    };
    return (React.createElement("label", { className: labelClassNameList, htmlFor: checkboxId },
        React.createElement("input", { id: checkboxId, className: inputClassNameList, type: "checkbox", "aria-invalid": !!errorMessage || undefined, "aria-describedby": errorMessage ? `error-${checkboxId}` : undefined, required: required ? true : undefined, "data-testid": testId, ...otherProps }),
        React.createElement("span", { className: "c-checkbox__label" },
            children,
            renderIfError(),
            renderIfRequired(required, requiredText))));
}
